module.exports = __webpack_public_path__ + "img/translate1.acb39095.jpg";